import { useDroppable } from "@dnd-kit/core";
import React from "react";

export function DommusDroppable({children, id}){
  const {setNodeRef, isOver} = useDroppable({
    id: id,
  });

  return (
    <div ref={setNodeRef} className={`${isOver ? 'is-over' : ''}`}>
      {children}
    </div>
  )
}
